/** "Standing" — where you're at right now: identity, overall gauge +
 *  trajectory, sharpest/working-on, and the per-category breakdown. */

import { useQuery } from "@tanstack/react-query";

import { fetchSkills } from "@/shared/api";
import { CategorySections } from "@/features/skills/components/CategorySections";
import { IdentityLine } from "@/features/skills/components/IdentityLine";
import { EmptyHero, OverallHero } from "@/features/skills/components/OverallHero";
import { OverallTrajectory } from "@/features/skills/components/OverallTrajectory";
import { SummaryStrip } from "@/features/skills/components/SummaryStrip";

export function StandingView() {
  const skills = useQuery({ queryKey: ["skills"], queryFn: fetchSkills });

  const allSkills = skills.data?.skills ?? [];
  const totalSignals = skills.data?.totalSignals ?? 0;
  const mappedSkills = allSkills.filter((s) => s.signalCount > 0);

  if (skills.isLoading) {
    return <div className="text-sm text-text-muted">Loading skills…</div>;
  }
  if (skills.error) {
    return (
      <div className="text-sm text-danger">
        Couldn't load skills:{" "}
        {skills.error instanceof Error ? skills.error.message : "Unknown error"}
      </div>
    );
  }
  if (totalSignals === 0) {
    return <EmptyHero />;
  }

  return (
    <div className="space-y-6">
      <IdentityLine />
      <OverallHero skills={mappedSkills} totalSignals={totalSignals} />
      <OverallTrajectory />
      <SummaryStrip skills={mappedSkills} />
      <CategorySections skills={allSkills} />
    </div>
  );
}
